import { useCallback, useEffect, useState } from "react";
import client from "../api/client";

/**
 * Hook to manage client details and related proposals
 */
export const useClientDetail = (id, showNotification) => {
	const [clientData, setClientData] = useState(null);
	const [proposals, setProposals] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchData = useCallback(async () => {
		if (!id) return;
		try {
			setLoading(true);
			const [clientRes, proposalsRes] = await Promise.all([
				client.get(`/clients/${id}`),
				client.get(`/clients/${id}/proposals`),
			]);
			setClientData(clientRes.data);
			setProposals(proposalsRes.data);
		} catch (error) {
			console.error("Error fetching client data:", error);
			if (showNotification) {
				showNotification("Erro ao carregar dados do cliente", "error");
			}
		} finally {
			setLoading(false);
		}
	}, [id, showNotification]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	const acceptedProposals = proposals.filter((p) => p.status === "ACCEPTED");
	const rejectedProposals = proposals.filter((p) => p.status === "REJECTED");
	const pendingProposals = proposals.filter((p) => p.status === "PENDING");
	const totalAcceptedValue = acceptedProposals.reduce(
		(sum, p) => sum + parseFloat(p.total_value || 0),
		0,
	);

	return {
		clientData,
		proposals,
		acceptedProposals,
		rejectedProposals,
		pendingProposals,
		totalAcceptedValue,
		loading,
		refresh: fetchData,
	};
};
